import { TModalConfig, TModalIdentifier } from 'models/Modals'
import { action, payload } from 'ts-action'

export const OpenModal = action('OpenModal', payload<TModalConfig>())

export const CloseModal = action('CloseModal', payload<TModalIdentifier>())

export const KillModal = action('KillModal', payload<TModalIdentifier>())

export const RefreshModalConfig = action('RefreshModalConfig', payload<TModalConfig>())

export const CloseAllModals = action('CloseAllModals')
